import { useEffect, useState } from "react";
import { getDocs } from "firebase/firestore";
import { orgQuery } from "@/lib/org";
import { fmtYearMonth } from "@/lib/format";
import { DriverProfile } from "@/types";

export default function DriversStats() {
  const [drivers, setDrivers] = useState<DriverProfile[]>([]);
  const [ym, setYm] = useState(fmtYearMonth());

  useEffect(() => {
    (async () => {
      const snap = await getDocs(orgQuery("drivers"));
      setDrivers(snap.docs.map((d) => ({ uid: d.id, ...(d.data() as any) })));
    })();
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">🚚 기사별 통계</h1>
        <input className="input max-w-[150px]" type="month" value={ym} onChange={(e) => setYm(e.target.value)} />
      </div>
      <div className="card">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-left">
            <tr>
              <th className="p-3">이름</th>
              <th className="p-3">권한</th>
              <th className="p-3 text-right">이번달 ({ym})</th>
              <th className="p-3 text-right">누적</th>
              <th className="p-3">최근 배송</th>
            </tr>
          </thead>
          <tbody>
            {drivers
              .sort((a, b) => (b.stats?.[`m_${ym}`] || 0) - (a.stats?.[`m_${ym}`] || 0))
              .map((d) => (
                <tr key={d.uid} className="border-t">
                  <td className="p-3 font-medium">{d.displayName || d.uid.slice(0, 8)}</td>
                  <td className="p-3">
                    <span className={`chip ${d.role === "admin" ? "bg-rose-100 text-rose-700" : "bg-milk-100 text-milk-700"}`}>
                      {d.role === "admin" ? "사장님" : d.role === "driver" ? "기사" : "권한 없음"}
                    </span>
                  </td>
                  <td className="p-3 text-right font-bold">{(d.stats?.[`m_${ym}`] || 0).toLocaleString()}</td>
                  <td className="p-3 text-right">{(d.stats?.total || 0).toLocaleString()}</td>
                  <td className="p-3 text-xs text-slate-500">
                    {d.stats?.lastDeliveredAt ? new Date((d.stats.lastDeliveredAt as any).seconds * 1000).toLocaleString("ko-KR") : "—"}
                  </td>
                </tr>
              ))}
            {drivers.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-slate-400">등록된 기사가 없습니다</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
